import { createTheme } from "@mui/material";

const systemTheme = createTheme()

export default systemTheme